import { useQuery } from '../useQuery/useQuery'
import { usePermission } from '../usePermission/usePermission'

import { scope } from '@percent/workplace-giving/common/hoc/withPermissions'
import { getContentTags } from '@percent/workplace-giving/api/tags/getContentTagAssignments/getContentTagAssignments'

export const useGetContentTags = () => {
  const has = usePermission()
  const hasContentTagsScope = has(scope('content_tags'))

  const { data } = useQuery(['getContentTags'], getContentTags, {
    enabled: hasContentTagsScope
  })

  return data ?? []
}
